module.exports = __webpack_public_path__ + "static/just-mercy-60b709d4d666e168be82603aadaf6a9b.jpg";